import profileRoutes from "@workspace/shared/core/services/profile/profile.routes";
import { api } from "@workspace/shared/core/services/api";
import {
  IInstallations,
  IInstallationsPayload,
  IProfile,
  ISubscription,
} from "@workspace/shared/core/types";

const onGetProfile = () => api.get<IProfile>(profileRoutes.profileRoute);

const onGetSubscriptions = () => api.get<ISubscription[]>(profileRoutes.subscriptionRoute);

const onGetInstallations = () => api.get<IInstallations>(profileRoutes.installationsRoute);

const onCreateInstallation = (payload: IInstallationsPayload) =>
  api.post<IInstallations>(profileRoutes.installationsRoute, payload);

/**
 * Revoke ALL of the user's active sessions (every app, every device) —
 * the dashboard's "close other sessions" takeover, same endpoint the
 * in-game dashboard uses. Only allowed on your own user id.
 */
const onRevokeLogin = (userId: number) => api.delete(profileRoutes.revokeLoginRoute(userId));

export default {
  onGetProfile,
  onGetSubscriptions,
  onGetInstallations,
  onCreateInstallation,
  onRevokeLogin,
};
